<template>
    <!-- Feature Section start -->
    <section id="feature" class="feature">
      <div class="feature-decor">
        <div class="feature-circle1"><img :src='"../../assets/images/feature2-blue.png"' alt=""></div>
      </div>
      <div class="container">
        <div class="row">
          <div class="feature-phone">
            <img :src='"../../assets/images/mockups/appsMockupLeft.png"' class="img-fluid" alt="">
          </div>
          <div class="offset-lg-4 col-lg-8">
            <div class="row">
              <div class="col-sm-12 mrgn-md-top" style="margin-top: 30px">
                <h2 class="title">{{$t("featureservice.Title")}}</h2>
              </div>
              <div class="col-12 col-md-6">
                <ul class="feature-style">
                  <li>
                    <div class="feature-subtitle">
                      <h3>{{$t("featureservice.service.1.Title")}}</h3>
                    </div>
                    <div>
                      <p class="height40">{{$t("featureservice.service.1.Body")}}</p>
                    </div>
                  </li>
                  <li>
                    <div class="feature-subtitle">
                      <h3>{{$t("featureservice.service.2.Title")}}</h3>
                    </div>
                    <div>
                      <p class="height60">{{$t("featureservice.service.2.Body")}}</p>
                    </div>
                  </li>
                  <li>
                    <div class="feature-subtitle">
                      <h3>{{$t("featureservice.service.3.Title")}}</h3>
                    </div>
                    <div>
                      <p class="height40">{{$t("featureservice.service.3.Body")}}</p>
                    </div>
                  </li>
                  <li>
                    <div class="feature-subtitle">
                      <h3>{{$t("featureservice.service.4.Title")}}</h3>
                    </div>
                    <div>
                      <p class="height60">{{$t("featureservice.service.4.Body")}}</p>
                    </div>
                  </li>
                </ul>
              </div>
              <div class="col-12 col-md-6 sm-m-top">
                <ul class="feature-style">
                  <li>
                    <div class="feature-subtitle">
                      <h3>{{$t("featureservice.service.5.Title")}}</h3>
                    </div>
                    <div>
                      <p class="height40">{{$t("featureservice.service.5.Body")}}</p>
                    </div>
                  </li>
                  <li>
                    <div class="feature-subtitle">
                      <h3>{{$t("featureservice.service.6.Title")}}</h3>
                    </div>
                    <div>
                      <p class="height60">{{$t("featureservice.service.6.Body")}}</p>
                    </div>
                  </li>

                  <li>
                    <div class="feature-subtitle">
                      <h3>{{$t("featureservice.service.7.Title")}}</h3>
                    </div>
                    <div>
                      <p class="height40">{{$t("featureservice.service.7.Body")}}</p>
                    </div>
                  </li>
                  <li>
                    <div class="feature-subtitle">
                      <h3>{{$t("featureservice.service.8.Title")}}</h3>
                    </div>
                    <div>
                      <p class="height60">{{$t("featureservice.service.8.Body")}}</p>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- Feature Section End -->
</template>
<script>
export default {
  name: 'FeatureService'
}
</script>
<style scoped>
  @media only screen and (min-width: 768px) {

    .height60 {
      height: 60px;
    }

    .height40 {
      height: 40px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/servicePage/featureservice.vue